import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {delay} from 'rxjs/operators';


interface MockRoute {
  url: RegExp | string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  status?: number;
  handler: any | ((req: HttpRequest<any>) => any); // data or function
}

// const mockData = [
//   {data: 123}
// ]

@Injectable()
export class MockBackendInterceptor implements HttpInterceptor {

  private mockRoutes: MockRoute[] = [
    // {
    //   url: /dashboard\/articles\/stsb\/.+/,
    //   method: 'GET',
    //   handler: mockData
    // },
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!req.url.includes('/api/')) {
      return next.handle(req);
    }

    const cleanUrl = req.url.split('?')[0].split('/api/')[1];
    const route = this.mockRoutes.find(r =>
      r.method === req.method &&
      (r.url instanceof RegExp ? r.url.test(cleanUrl) : r.url === cleanUrl)
    );
    if (route) {
      const bodyData = typeof route.handler === 'function'
        ? route.handler(req)
        : route.handler;

      const mockResponse = new HttpResponse({
        status: route.status || 200,
        body: {ok: (route.status || 200) < 400, response: bodyData}
      });
      return of(mockResponse).pipe(delay(300));
    }
    return next.handle(req);
  }
}


